/* import CalculateIcon from "@mui/icons-material/Calculate"; */
import Calculator from "./components/MathCalculator/Calculator";
import AgeCalculator from "./components/AgeCalculator/AgeCalculator";
import TextCaseConverter from "./components/TextCases/TextCaseConverter";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import TextCounter from "./components/TextCounter/TextCounter";
import SpaceRemover from "./components/SpaceRemover/SpaceRemover";
import TextReverser from "./components/TextReverser/TextReverser";
import PalindromeChecker from "./components/PalindromeChecker/PalindromeChecker";
import BMICalculator from "./components/BMICalculator/BMICalculator";
import UnitConverter from "./components/UnitConverter/UnitConverter";
import PrimeNumberChecker from "./components/PrimeNumberChecker/PrimeNumberChecker";
import GreatestCommonDivisor from "./components/GreatestCommonDivisor/GreatestCommonDivisor";
import LeastCommonMultiple from "./components/LeastCommonMultiple/LeastCommonMultiple";
import StatisticsCalculator from "./components/StatisticsCalculator/StatisticsCalculator";
import NumberSystemConverter from "./components/NumberSystemConverter/NumberSystemConverter";
import ColorConverter from "./components/ColorConverter/ColorConverter";
import PasswordGenerator from "./components/PasswordGenerator/PasswordGenerator";
import LoremIpsumGenerator from "./components/LoremIpsumGenerator/LoremIpsumGenerator";
import PasswordStrengthChecker from "./components/PasswordStrengthChecker/PasswordStrengthChecker";
import RandomDraw from "./components/RandomDraw/RandomDraw";
import RockPaperScissors from "./components/RockPaperScissors/RockPaperScissors";
import Notes from "./components/NotesTool/Notes";
import QrGenerator from "./components/QrGenerator/QrGenerator";
import BarcodeGenerator from "./components/BarcodeGenerator/BarcodeGenerator";

const toolsList = [
    // General tools
    {
        id: "calculator",
        title: "Basic Calculator",
        path: "calculator",
        component: <Calculator />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "notes",
        title: "Notes",
        path: "notes",
        component: <Notes />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "text-counter",
        title: "Text Counter",
        path: "text-counter",
        component: <TextCounter />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "space-remover",
        title: "Space Remover",
        path: "space-remover",
        component: <SpaceRemover />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "text-reverser",
        title: "Text Reverser",
        path: "text-reverser",
        component: <TextReverser />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "lorem-ipsum-generator",
        title: "Lorem Ipsum Generator",
        path: "lorem-ipsum-generator",
        component: <LoremIpsumGenerator />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "password-generator",
        title: "Password Generator",
        path: "password-generator",
        component: <PasswordGenerator />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "password-strength-checker",
        title: "Password Strength Checker",
        path: "password-strength-checker",
        component: <PasswordStrengthChecker />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "age-calculator",
        title: "Age Calculator",
        path: "age-calculator",
        component: <AgeCalculator />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "bmi-calculator",
        title: "BMI Calculator",
        path: "bmi-calculator",
        component: <BMICalculator />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "palindrome-checker",
        title: "Palindrome Checker",
        path: "palindrome-checker",
        component: <PalindromeChecker />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "random-draw",
        title: "Random Draw",
        path: "random-draw",
        component: <RandomDraw />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },
    {
        id: "rock-paper-scissors",
        title: "Rock Paper Scissors",
        path: "rock-paper-scissors",
        component: <RockPaperScissors />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        isActive: true,
    },

    // QR Generator tools
    {
        id: "qr-text",
        title: "QR Text / URL",
        path: "text",
        component: <QrGenerator type="text" title="QR Text / URL" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-wifi",
        title: "QR Wi-Fi",
        path: "wifi",
        component: <QrGenerator type="wifi" title="QR Wi-Fi" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-contact",
        title: "QR Contact (vCard)",
        path: "contact",
        component: <QrGenerator type="contact" title="QR Contact" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-email",
        title: "QR Email",
        path: "email",
        component: <QrGenerator type="email" title="QR Email" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-sms",
        title: "QR SMS",
        path: "sms",
        component: <QrGenerator type="sms" title="QR SMS" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-phone",
        title: "QR Phone",
        path: "phone",
        component: <QrGenerator type="phone" title="QR Phone" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-location",
        title: "QR Location",
        path: "location",
        component: <QrGenerator type="location" title="QR Location" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },
    {
        id: "qr-event",
        title: "QR Event",
        path: "event",
        component: <QrGenerator type="event" title="QR Event" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "qr-generator",
        isActive: true,
    },

    // Barcode Generator tools
    {
        id: "barcode-code128",
        title: "Code 128",
        path: "code-128",
        component: <BarcodeGenerator format="code128" title="Code 128" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-code39",
        title: "Code 39",
        path: "code-39",
        component: <BarcodeGenerator format="code39" title="Code 39" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-code93",
        title: "Code 93",
        path: "code-93",
        component: <BarcodeGenerator format="code93" title="Code 93" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-ean13",
        title: "EAN-13",
        path: "ean-13",
        component: <BarcodeGenerator format="ean13" title="EAN-13" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-ean8",
        title: "EAN-8",
        path: "ean-8",
        component: <BarcodeGenerator format="ean8" title="EAN-8" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-upca",
        title: "UPC-A",
        path: "upc-a",
        component: <BarcodeGenerator format="upca" title="UPC-A" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-upce",
        title: "UPC-E",
        path: "upc-e",
        component: <BarcodeGenerator format="upce" title="UPC-E" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-itf",
        title: "ITF",
        path: "itf",
        component: <BarcodeGenerator format="itf" title="ITF" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-itf14",
        title: "ITF-14",
        path: "itf-14",
        component: <BarcodeGenerator format="itf14" title="ITF-14" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-codabar",
        title: "Codabar",
        path: "codabar",
        component: <BarcodeGenerator format="codabar" title="Codabar" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-msi",
        title: "MSI",
        path: "msi",
        component: <BarcodeGenerator format="msi" title="MSI" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },
    {
        id: "barcode-pharmacode",
        title: "Pharmacode",
        path: "pharmacode",
        component: (
            <BarcodeGenerator format="pharmacode" title="Pharmacode" />
        ),
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "barcode-generator",
        isActive: true,
    },

    // Math tools
    {
        id: "mean-calculator",
        title: "Mean Calculator",
        path: "mean-calculator",
        component: <StatisticsCalculator type="mean" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },
    {
        id: "median-calculator",
        title: "Median Calculator",
        path: "median-calculator",
        component: <StatisticsCalculator type="median" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },
    {
        id: "mode-calculator",
        title: "Mode Calculator",
        path: "mode-calculator",
        component: <StatisticsCalculator type="mode" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },
    {
        id: "greatest-common-divisor",
        title: "Greatest Common Divisor",
        path: "greatest-common-divisor",
        component: <GreatestCommonDivisor />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },
    {
        id: "least-common-multiple",
        title: "Least Common Multiple",
        path: "least-common-multiple",
        component: <LeastCommonMultiple />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },
    {
        id: "prime-number-checker",
        title: "Prime Number Checker",
        path: "prime-number-checker",
        component: <PrimeNumberChecker />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "math-tools",
        isActive: true,
    },

    // Unit Converter tools
    {
        id: "length-converter",
        title: "Length Converter",
        path: "length-converter",
        component: <UnitConverter unitType="length" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "weight-converter",
        title: "Weight Converter",
        path: "weight-converter",
        component: <UnitConverter unitType="weight" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "temperature-converter",
        title: "Temperature Converter",
        path: "temperature-converter",
        component: <UnitConverter unitType="temperature" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "volume-converter",
        title: "Volume Converter",
        path: "volume-converter",
        component: <UnitConverter unitType="volume" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "area-converter",
        title: "Area Converter",
        path: "area-converter",
        component: <UnitConverter unitType="area" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "speed-converter",
        title: "Speed Converter",
        path: "speed-converter",
        component: <UnitConverter unitType="speed" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "time-converter",
        title: "Time Converter",
        path: "time-converter",
        component: <UnitConverter unitType="time" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "data-converter",
        title: "Data Converter",
        path: "data-converter",
        component: <UnitConverter unitType="data" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "energy-converter",
        title: "Energy Converter",
        path: "energy-converter",
        component: <UnitConverter unitType="energy" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },
    {
        id: "pressure-converter",
        title: "Pressure Converter",
        path: "pressure-converter",
        component: <UnitConverter unitType="pressure" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "unit-converter",
        isActive: true,
    },

    // Number system converters
    {
        id: "decimal-converter",
        title: "Decimal Converter",
        path: "decimal-converter",
        component: <NumberSystemConverter numberSystem="decimal" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "number-system",
        isActive: true,
    },
    {
        id: "binary-converter",
        title: "Binary Converter",
        path: "binary-converter",
        component: <NumberSystemConverter numberSystem="binary" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "number-system",
        isActive: true,
    },
    {
        id: "hexadecimal-converter",
        title: "Hexadecimal Converter",
        path: "hexadecimal-converter",
        component: <NumberSystemConverter numberSystem="hexadecimal" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "number-system",
        isActive: true,
    },
    {
        id: "octal-converter",
        title: "Octal Converter",
        path: "octal-converter",
        component: <NumberSystemConverter numberSystem="octal" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "number-system",
        isActive: true,
    },

    // Color converter tools
    {
        id: "hex-converter",
        title: "HEX Converter",
        path: "hex-converter",
        component: <ColorConverter type="hex" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "color-converter",
        isActive: true,
    },
    {
        id: "rgb-converter",
        title: "RGB Converter",
        path: "rgb-converter",
        component: <ColorConverter type="rgb" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "color-converter",
        isActive: true,
    },
    {
        id: "hsl-converter",
        title: "HSL Converter",
        path: "hsl-converter",
        component: <ColorConverter type="hsl" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "color-converter",
        isActive: true,
    },

    // Text case tools
    {
        id: "sentence-case",
        title: "Sentence Case",
        path: "sentence-case",
        component: <TextCaseConverter caseType="sentence-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "title-case",
        title: "Title Case",
        path: "title-case",
        component: <TextCaseConverter caseType="title-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "capitalize",
        title: "Capitalize",
        path: "capitalize",
        component: <TextCaseConverter caseType="capitalize" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "uppercase",
        title: "Uppercase",
        path: "uppercase",
        component: <TextCaseConverter caseType="uppercase" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "lowercase",
        title: "Lowercase",
        path: "lowercase",
        component: <TextCaseConverter caseType="lowercase" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "toggle-case",
        title: "Toggle Case",
        path: "toggle-case",
        component: <TextCaseConverter caseType="toggle-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "camel-case",
        title: "Camel Case",
        path: "camel-case",
        component: <TextCaseConverter caseType="camel-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "pascal-case",
        title: "Pascal Case",
        path: "pascal-case",
        component: <TextCaseConverter caseType="pascal-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "snake-case",
        title: "Snake Case",
        path: "snake-case",
        component: <TextCaseConverter caseType="snake-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "screaming-snake-case",
        title: "Screaming Snake Case",
        path: "screaming-snake-case",
        component: (
            <TextCaseConverter caseType="screaming-snake-case" />
        ),
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "kebab-case",
        title: "Kebab Case",
        path: "kebab-case",
        component: <TextCaseConverter caseType="kebab-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "train-case",
        title: "Train Case",
        path: "train-case",
        component: <TextCaseConverter caseType="train-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "dot-case",
        title: "Dot Case",
        path: "dot-case",
        component: <TextCaseConverter caseType="dot-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "path-case",
        title: "Path Case",
        path: "path-case",
        component: <TextCaseConverter caseType="path-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
    {
        id: "cobol-case",
        title: "Cobol Case",
        path: "cobol-case",
        component: <TextCaseConverter caseType="cobol-case" />,
        icon: <KeyboardArrowRightOutlinedIcon />,
        description: "",
        group: "text-case",
        isActive: true,
    },
];

export default toolsList;
